<template>
  <div class="m-content" >
    <CareerCode v-for="(item,index) in cosCareer" :content="item" v-on:listenToChildEvent="getUserAnswer"></CareerCode>
    <div class="btn-group">
      <button class="default-btn large-btn" :class="show?'half-opacity':''" v-if="showButton" @click="showNext" v-preventReClick>下一个职业</button>
      <button class="default-btn large-btn submit-btn" :class="show?'half-opacity':''"  v-if="showSubmit" @click="submitData" v-preventReClick>提交</button>
    </div>
  </div>
</template>
<script>
import CareerCode from '../components/CareerCode.vue'
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  props: {
    id: Number
  },
  name: 'CareerMatch',
  components: {
    'CareerCode':CareerCode
  },
  data() {
    return {
      cosCareer:[],
      show:true,
      showButton:true,
      showSubmit:false,
      current:0,
      currentAnswer:'',
      result:'',
      submitNum:0
    }
  },
	computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
	},
  created(){
    setWechatTitle('生涯驿站-职业倾向匹配');
    this.getReport()
  },
  methods:{
    //获取第5关的报告信息
    getReport(){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosCareerReport.do'
        };
        axios(options)
        .then((response)=>{
          let Result = response.data.data;
           if(Result){
             let cosCareer=Result.cosCareer;
             cosCareer.listCareer.map((item,index)=>{
                item.no=index+1
                if(!index){
                  item.show=true
                }else{
                  item.show=false
                }
                this.$set(this.cosCareer,index,item)
             })
           }
        })
        .catch((error)=>{
          console.log(error);
        })
    },
    // 存储当前的答案
    getUserAnswer(content){
      this.show=false
      this.currentAnswer = content
    },
    // 显示下一题
    showNext(){
      if(!this.show){
        this.cosCareer[this.current].show=false
        this.cosCareer[this.current+1].show=true
        if(this.current+1==3){
          this.showButton = false
          this.showSubmit = true
        }
        this.result+=this.currentAnswer
        this.current++
        this.show=true
      }
    },
    // 提交答案
    submitData(){
      if(this.current==3&&this.submitNum==0){
        this.submitNum =1
        this.result+=this.currentAnswer
        const options = {
          method: 'POST',
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          },
          data: qs.stringify({
            submitdata: this.result,
            openId: this.shengyaUser.openid
          }),
          url: '/cob/saveCosMatchAnswer..do'
        };
        axios(options)
          .then((response)=>{
            if(response.data.result.success){
              let cosMatchAnswer = response.data
              let shengyaUser = cosMatchAnswer.data.user
              this.$bus.$emit('play-finish', shengyaUser)
            }else{
              this.$store.commit('showMessage', {
                message: res.data.result.message,
                type: 'error'
              })
            }
          })
          .catch((error)=>{
            console.log(error);
          });
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .tip
    position:fixed
    bottom:2rem
    width: 100%
    max-width: 12rem
    text-align:center
    span
      font-size:0.36rem
  .label-box
    overflow:hidden
    .career-label
      float:left
      width:50%
      background-color:#FF7F00
      p
        color:#ffffff
        text-align:center
        marign:0.2rem auto
      .label-name
        font-size:0.36rem
        height: 0.8rem
        display: flex
        display: -webkit-flex
        justify-content: center
        align-items: center
        -webkit-align-items: center
      .label-score
        font-size:0.56rem
    .career-label:nth-child(1)
      background-color:#7DB0DF
    .career-label:nth-child(2)
      background-color:#C1D659
    .career-label:nth-child(3)
      background-color:#F3A772
</style>
